'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var heroTitle = context.getElement('.' + context.className + '_Title');
  var heroSubTitle = context.getElement('.' + context.className + '_SubTitle');
  var heroButton = context.getElement('.' + context.className + '_Button');
  var heroCta = context.getElement('.' + context.className + '_Cta');
  var heroHeader = (0, _functional.getElement)('.' + context.className + '_Header');

  var titleArr = heroTitle.textContent.split('');

  var finalTitle = '<span class="sec-Animation_Word">';

  for (var i = 0, len = titleArr.length; i < len; i++) {
    finalTitle += titleArr[i] === ' ' ? '</span> <span class="sec-Animation_Word">' : '<span class="sec-Animation_Letter">' + titleArr[i] + '</span>';
  }

  finalTitle += '</span>';

  heroTitle.innerHTML = finalTitle;

  var letterAnimations = context.getElements('.sec-Animation_Letter');
  var animationDelay = 1000;

  letterAnimations.forEach(function (letterAnimation) {
    setTimeout(function (e) {
      letterAnimation.classList.add('sec-Animation_Letter-active');
    }, animationDelay);

    animationDelay = animationDelay + 25;
  });

  if (heroSubTitle) {
    setTimeout(function (e) {
      heroSubTitle.classList.add('sec-Animation_FadeUp-active');
    }, animationDelay);

    animationDelay = animationDelay + 200;
  }

  if (heroButton) {
    setTimeout(function (e) {
      heroButton.classList.add('sec-Animation_FadeUp-active');
    }, animationDelay);

    animationDelay = animationDelay + 200;
  }

  if (heroHeader) {
    heroHeader.classList.add('sec-Animation_FadeDown');

    setTimeout(function (e) {
      heroHeader.classList.add('sec-Animation_FadeDown-active');
    }, animationDelay);
  }

  if (heroCta) {
    setTimeout(function (e) {
      heroCta.classList.add('sec-Animation_FadeUp-active');
    }, animationDelay);
  }
}